import createRouter from 'router5';
import listenersPlugin from 'router5/plugins/listeners';
import browserPlugin from 'router5/plugins/browser';
import routes from './routes';

const router = createRouter(routes, {
		defaultRoute: 'list',
		autoCleanUp: true
	})
	.usePlugin(listenersPlugin())
	.usePlugin(browserPlugin({
		useHash: true
	}));

let nextState = null;


function navigateToState(dependencies, toState, fromState) {
	nextState = toState;
	const toRoute = routes.find(r => r.name === toState.name);
	if (!toRoute || !toRoute.onActivate) {
		return Promise.resolve({ ...toState
		});
	}			
	return Promise.resolve({})
		.then(() => toRoute.onActivate(dependencies.store, toState, fromState))
		.then(() => ({ ...toState
		}));
}

function OnActivateMiddlewareFactory(routes) {
	return (router, dependencies) => {
		return (toState, fromState) => {
			return navigateToState(dependencies, toState, fromState);
		};
	};
}

router.useMiddleware(OnActivateMiddlewareFactory(routes));

// Hack to fix IE
window.onhashchange = function () {
	setTimeout(function () {
		let hash = window.location.hash;
		hash = hash.replace(new RegExp('^#'), '');
		let state = router.matchPath(hash);
		let currentState = router.getState();
		//if (state && currentState && nextState && (state.path !== currentState.path) && (state.path !== nextState.path)) {
			navigateToState(router.getDependencies(), state, currentState);
		//}
	}, 10);
}

export default router;